import { CONFIG } from '../config/config.js';

export const resumeStorage = {
  saveProgress(uploadId, data) {
    try {
      const resumeData = {
        uploadId,
        fileName: data.fileName,
        fileSize: data.fileSize,
        totalChunks: data.totalChunks,
        uploadedChunks: data.uploadedChunks || [],
        chunkSize: data.chunkSize,
        userId: data.userId,
        organizationId: data.organizationId,
        timestamp: Date.now(),
        expiryTime: Date.now() + (CONFIG.RESUME_EXPIRY_HOURS * 60 * 60 * 1000),
      };

      sessionStorage.setItem(
        `${CONFIG.RESUME_STORAGE_KEY}_${uploadId}`,
        JSON.stringify(resumeData)
      );

      return true;
    } catch (error) {
      console.error('Failed to save resume data:', error);
      return false;
    }
  },

  getProgress(uploadId) {
    try {
      const key = `${CONFIG.RESUME_STORAGE_KEY}_${uploadId}`;
      const data = sessionStorage.getItem(key);

      if (!data) return null;

      const resumeData = JSON.parse(data);

      if (Date.now() > resumeData.expiryTime) {
        this.clearProgress(uploadId);
        return null;
      }

      return resumeData;
    } catch (error) {
      console.error('Failed to get resume data:', error);
      return null;
    }
  },

  clearProgress(uploadId) {
    try {
      sessionStorage.removeItem(`${CONFIG.RESUME_STORAGE_KEY}_${uploadId}`);
      return true;
    } catch (error) {
      console.error('Failed to clear resume data:', error);
      return false;
    }
  },

  getAllPendingUploads() {
    const pending = [];
    try {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key?.startsWith(CONFIG.RESUME_STORAGE_KEY)) {
          const uploadId = key.replace(`${CONFIG.RESUME_STORAGE_KEY}_`, '');
          const data = this.getProgress(uploadId);
          if (data) pending.push(data);
        }
      }
    } catch (error) {
      console.error('Failed to get pending uploads:', error);
    }
    return pending;
  },
};

/**
 * Save resume data for an upload
 * @param {string} uploadId - Upload ID
 * @param {Object} data - Resume data
 */
export function saveResumeData(uploadId, data) {
  return resumeStorage.saveProgress(uploadId, data);
}

/**
 * Load resume data for an upload
 * @param {string} uploadId - Upload ID
 * @returns {Object|null} Resume data or null if not found/expired
 */
export function loadResumeData(uploadId) {
  return resumeStorage.getProgress(uploadId);
}

/**
 * Clear resume data for an upload
 * @param {string} uploadId - Upload ID
 */
export function clearResumeData(uploadId) {
  return resumeStorage.clearProgress(uploadId);
}

/**
 * Get all pending uploads
 * @returns {Array} Array of pending upload data
 */
export function getAllPendingUploads() {
  return resumeStorage.getAllPendingUploads();
}